import { withPrismicPreview } from "gatsby-plugin-prismic-previews";
import React, { useContext, useEffect, useState } from "react";
import { graphql, navigate, useStaticQuery } from "gatsby";
import { SliceZone } from "@prismicio/react";
import { Layout } from "../../components/Layout";
import Indicators from "../../components/indicators";
import { components } from "../../components";
import { getNews, getUserProgress } from "../../services/integrationsServices";
import GlobalLoading from "../../components/global-loading";
import { AppContext } from "../../contexts/global";
import News from "../../components/news";
import Blog from "../../components/blog";
import BannerFront from "../../components/banner/BannerFront";
import { Form, Select } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { getIndicators, getDependencies, getUserByEmail, navsStoreCodes } from "../../services/appServices";
import { validateDirectivas, getNitStores } from "../../utils/utils";

const Home = () => {
  const QueryHome = useStaticQuery(graphql`
    {
      allPrismicHome {
        edges {
          node {
            data {
              body {
                ... on PrismicHomeDataBodyIndicador {
                  id
                  items {
                    message
                    orientation
                    type
                    id
                  }
                  primary {
                    id
                    group
                    design
                  }
                  slice_type
                }
              }
              body1 {
                ... on PrismicHomeDataBody1Modulos {
                  id
                  items {
                    module
                    color
                    icon
                    id
                    link {
                      url
                      link_type
                      uid
                      type
                    }
                  }
                  slice_type
                  primary {
                    accesos_comercial {
                      raw
                    }
                  }
                }
                ... on PrismicHomeDataBody1Empleados {
                  id
                  items {
                    module
                    color
                    icon
                    id
                    link {
                      url
                      link_type
                      uid
                      type
                    }
                  }
                  slice_type
                  primary {
                    accesos_empleados {
                      raw
                    }
                  }
                }
                ... on PrismicHomeDataBody1Proveedores {
                  id
                  items {
                    module
                    color
                    icon
                    id
                    link {
                      url
                      link_type
                      uid
                      type
                    }
                  }
                  slice_type
                  primary {
                    accesos_proveedores {
                      raw
                    }
                  }
                }
                ... on PrismicHomeDataBody1Banner {
                  id
                  slice_type
                  primary {
                    background
                    image {
                      url
                      alt
                    }
                  }
                }
              }
              title
            }
          }
        }
      }
    }
  `);

  const [data, setData] = useState({});
  const [loader, setLoader] = useState(true);
  const { user, directivas } = useContext(AppContext);
  const [dataNews, setDataNews] = useState([]);
  const [dataBlogs, setDataBlogs] = useState([]);
  const [indicatorInfo, setIndicatorInfo] = useState();
  const [dataIndicators, setDataIndicators] = useState([]);
  const [form] = Form.useForm();
  const [dataSlices, setDataSlices] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [stores, setStores] = useState([]);
  const [filterInfoStore, setFilterStores] = useState([]);
  const [hasIndicators, setHasIndicators] = useState(false);
  const [navStoreCode, setNavStoreCode] = useState([]);
  const handleChange = (value) => {
    const selected = dataIndicators.find((data) => data.tienda === value);
    setIndicatorInfo(selected);
  };

  useEffect(() => {
    if (user.email) getInitInfo();
    setTimeout(() => {
      setLoader(false);
    }, 600);
  }, [user]);

  const validateLength = (news) => {
    if (news && news.length > 3) {
      return [{ ...news[0] }, { ...news[1] }, { ...news[2] }];
    }
    return news;
  };

  const searchIndicators = async () => {
    const currentUser = await getUserByEmail(user.email, user["token"]);

    if (!currentUser || !currentUser.user) {
      setHasIndicators(false);
      return [];
    }

    const navStoreCode = currentUser.user["custom:navstorecode"] || user["custom:navstorecode"];
    setNavStoreCode(navStoreCode);

    const params = {
      app: process.env.CLIENT_ID,
      cargo: user["custom:position"],
      table: "cargos-aplicacion",
      codigonav: navStoreCode,
      employeeid: parseInt(user["custom:employeeid"]),
    };

    const items = await getIndicators(params, user["token"]);

    if (items && items.length) {
      setIndicatorInfo(items[0]);
      setHasIndicators(true);
    } else {
      setHasIndicators(false);
    }

    return items;
  };

  const getInitInfo = async () => {
    const Edukando = await getUserProgress(user.email);
    const news = await getNews();
    const indicatorsData = await searchIndicators();

    setDataIndicators(indicatorsData);

    if (news && Array.isArray(news) && news.length) {
      let blog = news.filter((e) => e.categories === "comunicado");
      let noticias = news.filter((e) => e.categories != "comunicado");
      blog = validateLength(blog);
      noticias = validateLength(noticias);
      setDataBlogs(blog);
      setDataNews(noticias);
    }
    const serviceData = { Edukando };
    setData(serviceData);

    const slices = QueryHome.allPrismicHome.edges[0]?.node?.data?.body1;
    if (slices) {
      slices.forEach(slice => {
        if (slice.id === 'modulo.controlasistencia') {
          let agregado = false;
          if (slice.items?.[0]?.link?.url?.indexOf(user["custom:position"]) < 0) {
            slice.items[0].link.url += "?rol=" + user["custom:position"] + "&num=" + user["custom:employeeid"];
            agregado = true;
          }
        }
      });
      setDataSlices(slices);
    }
  };
  const fectchStore = async () => {
    try {
      if (!navStoreCode || !user["token"]) return;
      const getInfoTienda = await navsStoreCodes(navStoreCode, user["token"]);
      setStores(getInfoTienda || []);
      const filterInfoStore = (getInfoTienda || []).filter(tienda => dataIndicators.some(data => data.tienda === tienda.almacennav));
      setFilterStores(filterInfoStore);
    } catch (error) {
      return error.message;
    }
  };

  useEffect(() => {

    fectchStore();
  }, [dataIndicators, navStoreCode, user]);

  const title = QueryHome.allPrismicHome.edges[0]?.node?.data?.title;
  const indicators = QueryHome.allPrismicHome.edges[0]?.node?.data?.body?.filter(
    ({ slice_type }) => slice_type === "indicador"
  );

  // Obtener datos del banner promocional desde Prismic
  const bannerSlice = QueryHome.allPrismicHome.edges[0]?.node?.data?.body1?.find(
    ({ slice_type }) => slice_type === "banner"
  );
  const bannerImage = bannerSlice?.primary?.image?.url;
  const bannerAlt = bannerSlice?.primary?.image?.alt || "Banner promocional Yamaha";

  return (
    <AppContext.Consumer>
      {(theme) => (
        <Layout>
          {loader && <GlobalLoading />}
          {!loader && (
            <section className="indicators">
              {/* Banner de bienvenida - Permanece fijo */}
              <BannerFront />
              
              {/* Banner promocional desde Prismic */}
              {bannerImage && (
                <div className="secondary-banner">
                  <img
                    src={bannerImage}
                    alt={bannerAlt}
                    className="secondary-banner-image"
                  />
                </div>
              )}

              {hasIndicators && (
                <>
                  <div className="indicators-container-title">
                    <h3 className="indicators-title">{title}</h3>
                    {dataIndicators && dataIndicators.length > 0 && (
                      <Form form={form} className="indicators-select">
                        <Form.Item
                          label="Tienda"
                          tooltip={{
                            title:
                              "Selecciona una tienda para ver los indicadores correspondientes.",
                            icon: <InfoCircleOutlined />,
                          }}
                        >
                          <Select
                            defaultValue={dataIndicators[0]?.tienda}
                            data-testid='changeTienda'
                            onChange={(value) => handleChange(value)}
                          >
                            {dataIndicators.map((data) => {
                              const filterStore = filterInfoStore.find(tienda => tienda.almacennav === data.tienda);
                              return (
                                <Select.Option value={data.tienda} key={data.tienda}>
                                  {filterStore ? `${filterStore.almacennav} - ${filterStore.razonsocial} - ${filterStore.direccion}` : data.tienda}
                                </Select.Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      </Form>
                    )}
                  </div>
                  <Indicators
                    items={indicators}
                    data={data}
                    indicatorInfo={indicatorInfo}
                  />
                </>
              )}
              <SliceZone slices={dataSlices} components={components} />

              {/* Blog y noticias */}
              {validateDirectivas(directivas, "home.noticias") && <News news={dataNews} />}
            </section>
          )}
        </Layout>
      )}
    </AppContext.Consumer>
  );
};

export default withPrismicPreview(Home);